import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';
import { PermissionService } from "@app/authentication/services/permission.service";
import { Observable } from "rxjs";


/**
 * Guard class for allowing access only for users with the {@link Role} of admin.
 */
@Injectable()
export class PermissionBasedGuard implements CanActivate, CanActivateChild {
    readonly TOOL_MANAGEMENT = 'tool-management';
    readonly TOOL_USAGE = 'tool-usage';
    readonly TOOL_MAINTENANCE = 'tool-maintenance-plans';
    readonly TOOL_REQUEST = 'tool-request';
    readonly APPROVE_TOOL_REQUESTS_LINES = 'tool-requests-lines';
    readonly APPROVE_TOOL_REQUESTS_FACILITIES = 'tool-requests-facilities';
    readonly APPROVE_TOOL_RETURNS_LINES = 'tool-returns-lines';
    readonly APPROVE_TOOL_RETURNS_FACILITIES = 'tool-returns-facilities';
    readonly INSERTION_CYCLES = 'insertion-cycles';
    readonly LIFT_MANAGEMENT = 'lifts';


    constructor(private router: Router,
                private authenticationService: AuthenticationService,
                private permissionService: PermissionService) {
    }


    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (!this.permissionService.hasPermissionForPage(this.authenticationService.getUserDetails(), route.url.toString())) {
            this.router.navigate(['/']);
            return false;
        }

        return true;
    }


    canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        let canActivateBase = false;

        if (state.url && state.url.indexOf(this.TOOL_MANAGEMENT) > 0) {
            canActivateBase = this.permissionService
                .hasPermissionForPage(this.authenticationService.getUserDetails(), this.TOOL_MANAGEMENT);
        }

        if (state.url && state.url.indexOf(this.TOOL_USAGE) > 0) {
            canActivateBase = this.permissionService
                .hasPermissionForPage(this.authenticationService.getUserDetails(), this.TOOL_USAGE);
        }

        if (state.url && state.url.indexOf(this.TOOL_MAINTENANCE) > 0) {
            canActivateBase = this.permissionService
                .hasPermissionForPage(this.authenticationService.getUserDetails(), this.TOOL_MAINTENANCE);
        }

        if (state.url && state.url.indexOf(this.TOOL_REQUEST) > 0) {
            canActivateBase = this.permissionService
                .hasPermissionForPage(this.authenticationService.getUserDetails(), this.TOOL_REQUEST);
        }

        if (state.url && state.url.indexOf(this.APPROVE_TOOL_REQUESTS_LINES) > 0) {
            canActivateBase = this.permissionService
                .hasPermissionForPage(this.authenticationService.getUserDetails(), this.APPROVE_TOOL_REQUESTS_LINES);
        }

        if (state.url && state.url.indexOf(this.APPROVE_TOOL_REQUESTS_FACILITIES) > 0) {
            canActivateBase = this.permissionService
                .hasPermissionForPage(this.authenticationService.getUserDetails(), this.APPROVE_TOOL_REQUESTS_FACILITIES);
        }

        if (state.url && state.url.indexOf(this.APPROVE_TOOL_RETURNS_LINES) > 0) {
            canActivateBase = this.permissionService
                .hasPermissionForPage(this.authenticationService.getUserDetails(), this.APPROVE_TOOL_RETURNS_LINES);
        }

        if (state.url && state.url.indexOf(this.APPROVE_TOOL_RETURNS_FACILITIES) > 0) {
            canActivateBase = this.permissionService
                .hasPermissionForPage(this.authenticationService.getUserDetails(), this.APPROVE_TOOL_RETURNS_FACILITIES);
        }

        if (state.url && state.url.indexOf(this.INSERTION_CYCLES) > 0) {
            canActivateBase = this.permissionService
                .hasPermissionForPage(this.authenticationService.getUserDetails(), this.INSERTION_CYCLES);
        }

        if (state.url && state.url.indexOf(this.LIFT_MANAGEMENT) > 0) {
            canActivateBase = this.permissionService
                .hasPermissionForPage(this.authenticationService.getUserDetails(), this.LIFT_MANAGEMENT);
        }

        if (!canActivateBase) {
            this.router.navigate(['/']);
        }

        return canActivateBase;
    }
}
